"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _postDetail = _interopRequireDefault(require("./postDetail.vue"));
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'expandList',
  components: {
    postDetail: _postDetail.default
  },
  props: {
    actId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newVal) {
        console.log('actId', newVal);
        // 有actId时选中，无actId时不选
        if (newVal && newVal != 'null' && newVal != '') {
          this.searchForm.taskId = Number(newVal);
          this.searchForm.page = 1;
          this.fetchList();
        }
        this.searchForm.taskId = newVal && newVal != 'null' ? newVal : '';
      }
    }
  },
  data: function data() {
    return {
      showRewardDialog: false,
      rewardList: [],
      rewardLoading: false,
      showPostDialog: false,
      loading: false,
      searchForm: {
        taskId: '',
        cardNo: '',
        mobile: '',
        page: 1,
        limit: 10,
        total: 0,
        postStatus: '',
        qualityLevel: ''
      },
      times: [],
      postStatusList: [{
        label: '待审核',
        value: '1'
      }, {
        label: '系统审核通过',
        value: '2'
      }, {
        label: '系统审核不通过',
        value: '3'
      }, {
        label: '审核通过不发奖励',
        value: '4'
      }, {
        label: '人工审核通过',
        value: '6'
      }, {
        label: '人工审核不通过',
        value: '5'
      }, {
        label: '人工审核通过不发奖励',
        value: '7'
      }, {
        label: '已发奖励',
        value: '8'
      }, {
        label: '优质帖待审核',
        value: '9'
      }, {
        label: '优质帖审核通过',
        value: '10'
      }, {
        label: '优质帖审核不通过',
        value: '11'
      }, {
        label: '优质帖奖励已发放',
        value: '12'
      }],
      actLists: [],
      tableData: [],
      showUserDialog: false,
      // 控制弹窗显示

      dialogVisible: false,
      downloadLoading: false,
      selectedPost: {} // 选中的帖子详情
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    postReward: function postReward(row) {
      var _this = this;
      var data = {
        taskId: row.taskId,
        postId: row.id,
        cardNo: row.cardNo,
        mobile: row.mobile,
        auditId: ''
      };
      this.rewardLoading = true;
      _redbook.default.getPostRewardInfo(data).then(function (res) {
        // 兼容分页接口
        var records = res && (res.records || res.data || res) || [];
        // 尝试格式化时间字段
        records.forEach(function (r) {
          if (r.createDate) r.createDate = _this.dateFormat2(r.createDate);
        });
        _this.rewardList = records;
        _this.showRewardDialog = true;
      }).catch(function (err) {
        _this.$message.error(err && err.message || '获取奖励信息失败');
      }).finally(function () {
        _this.rewardLoading = false;
      });
    },
    download: function download() {
      var _this2 = this;
      this.downloadLoading = true;
      var params = {
        taskId: this.searchForm.taskId,
        cardNo: this.searchForm.cardNo,
        mobile: this.searchForm.mobile,
        postStatus: this.searchForm.postStatus
      };
      _redbook.default.exportPostList(params).then(function (response) {
        var blob = new Blob([response], {
          type: 'application/vnd.ms-excel'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '帖子列表.xlsx';
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).finally(function () {
        _this2.downloadLoading = false;
      });
    },
    changeTime: function changeTime(e) {
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
      }
    },
    postDetail: function postDetail(row) {
      // redBookApi.getPostDetail(row.id).then(res => {
      //     console.log(res);
      //     this.selectedPost = res || {}
      //     this.showPostDialog = true

      // })
      // show post detail dialog; use row directly (postDetail.vue will handle parsing image lists)
      this.selectedPost = row || {};
      this.showPostDialog = true;
    },
    dateFormat2: function dateFormat2(date, format) {
      var d = date instanceof Date ? date : new Date(date);
      if (isNaN(d.getTime())) return '';
      var map = {
        'yyyy': d.getFullYear(),
        'MM': ('0' + (d.getMonth() + 1)).slice(-2),
        'dd': ('0' + d.getDate()).slice(-2),
        'HH': ('0' + d.getHours()).slice(-2),
        'mm': ('0' + d.getMinutes()).slice(-2),
        'ss': ('0' + d.getSeconds()).slice(-2)
      };
      var fmt = format || 'yyyy-MM-dd HH:mm:ss';
      Object.keys(map).forEach(function (k) {
        fmt = fmt.replace(k, map[k]);
      });
      return fmt;
    },
    fetchList: function fetchList() {
      var _this3 = this;
      this.loading = true;
      console.log(this.searchForm);
      _redbook.default.xyXhsUserPost(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          if (item.createDate) {
            item.createDate = _this3.dateFormat2(item.createDate);
          }
        });
        _this3.tableData = res.records || [];
        _this3.searchForm.total = res.total || 0;
      }).finally(function () {
        _this3.loading = false;
      });
    },
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleDetail: function handleDetail(row, id) {
      var _this4 = this;
      this.$emit('detailPost', row);
      _redbook.default.getPostDetail(id).then(function (res) {
        console.log(res);
        _this4.selectedPost = res || {};
      });
      this.dialogVisible = true;
    },
    getActList: function getActList() {
      var _this5 = this;
      var data = {
        startTime: '',
        endTime: '',
        taskName: '',
        taskType: '',
        status: '',
        page: 1,
        limit: 999999,
        total: 0
      };
      _redbook.default.xyXhsTask(data).then(function (res) {
        _this5.actLists = res.records || [];
        // if (res.records[0] && (this.actId == 'null' || this.actId == '')) {
        //     this.searchForm.taskId = res.records[0].id
        //     this.fetchList(res.records[0].id)
        // }
      });
    }
  },
  mounted: function mounted() {
    this.getActList();
    this.fetchList();
  }
};